import { html, render } from 'lit-html';
import * as brandStyles from 'url:../../brand.css';
import * as globalStyles from 'url:../../global.css';
import * as navStyles from 'url:./style.css';
import * as dansLogo from 'url:../../assets/logo.png';
import * as menuIcon from 'url:../../assets/menu.svg';
import * as gclefIcon from 'url:../../assets/g-clef.svg';

class NavBar extends HTMLElement {
  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
  }

  static get observedAttributes() {
    return ['mainText'];
  }

  get mainText() {
    return this.getAttribute('mainText');
  }

  set mainText(value) {
    this.setAttribute('mainText', value);
  }

  attributeChangedCallback() {
    this.render();
  }

  connectedCallback() {
    this.render();

    // Attach events directly after first render
    const navToggle = this.shadow.querySelector('.nav-toggle');
    const navMenu = this.shadow.querySelector('.nav-menu');
    const logo = this.shadow.querySelector('.logo');
    const notesContainer = this.shadow.querySelector('.logo-notes');

    if (navToggle && navMenu) {
      navToggle.addEventListener('click', () => {
        const isOpen = navMenu.classList.toggle('open');
        navToggle.classList.toggle('open', isOpen);
        navToggle.setAttribute('aria-expanded', String(isOpen));
      });
    }

    if (logo && notesContainer) {
      // ♫ ♪ ♬ ♩ ♯ ♭
      const notes = [
        '\u266B',
        '\u266A',
        '\u266C',
        '\u2669',
        '\u266F',
        '\u266D',
      ];
      logo.addEventListener('mouseenter', () => {
        for (let i = 0; i < 3; i++) {
          const note = document.createElement('span');
          note.className = 'logo-note';
          note.textContent = notes[Math.floor(Math.random() * notes.length)];
          note.style.left = `${40 + i * 20 - Math.random() * 20}px`;
          note.style.animationDelay = `${i * 0.12 + Math.random() * 0.08}s`;
          notesContainer.appendChild(note);
          note.addEventListener('animationend', () => note.remove(), {
            once: true,
          });
        }
      });
    }
  }

  render() {
    const homeClass = this.mainText === 'home' ? 'active' : '';
    const aboutClass = this.mainText === 'about' ? 'active' : '';
    const bioClass = this.mainText === 'bio' ? 'active' : '';

    const template = html`
      <link href="${brandStyles}" rel="stylesheet" />
      <link href="${globalStyles}" rel="stylesheet" />
      <link href="${navStyles}" rel="stylesheet" />
      <header>
        <nav class="navbar">
          <div class="container">
            <a href="/" class="logo" aria-label="Home">
              <img src="${dansLogo}" alt="Dan’s Music Lessons Logo" />
              <span class="logo-notes"></span>
            </a>
            <button
              class="nav-toggle"
              aria-label="Toggle navigation"
              aria-expanded="false"
              aria-controls="nav-menu"
            >
              <img src="${menuIcon}" alt="Menu" class="hamburger-icon" />
              <img src="${gclefIcon}" alt="G Clef" class="gclef-icon" />
            </button>
            <ul class="nav-menu" id="nav-menu">
              <li><a href="/" class="${homeClass} frijole-regular">Home</a></li>
              <li>
                <a href="/about" class="${aboutClass} frijole-regular"
                  >Lessons/ Sign Up</a
                >
              </li>
              <li>
                <a href="/bio" class="${bioClass} frijole-regular">Bio</a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    `;
    render(template, this.shadow);
  }
}

customElements.define('nav-bar', NavBar);
